module.exports = "/images/sm.svg?cb9114f13498ec16363af4232157d227";